// extracted by css-extract-rspack-plugin
export default {"cls1":"TasteOfMentionsUpsellModal-cls1_SBn","cls2":"TasteOfMentionsUpsellModal-cls2_wMR TasteOfMentionsUpsellModal-cls1_SBn"};